/* eslint-disable @typescript-eslint/no-unused-vars */

import { AxiosResponse, CancelToken } from 'axios';
import { OAuth2Client } from '@kolorado/oauth';
import {
  GetAllCommandsByDeviceKeyRequest,
  PatchCommandsByDeviceKeyRequest,
  PostCommandsByDeviceKeyRequest,
  GetCommandByID,
} from './types';
import { Command as CommandEntity } from '../entities/commands-v1/command';
import { CommandResponse } from '../entities/commands-v1/models';
import { axiosInstance } from "../axios-instance";

class Command {
  private authClient: OAuth2Client | null;

  private baseUrl: string;

  constructor(authClient: OAuth2Client | null, baseUrl: string) {
    this.authClient = authClient;
    this.baseUrl = baseUrl;
  }

  getCommandById(input: GetCommandByID): Promise<AxiosResponse<CommandEntity>> {
    const { commandId, ...queryParameters } = input;
    const accessToken = localStorage.getItem('accessToken');
    return axiosInstance.get<CommandEntity>(`${this.baseUrl}/${commandId}`, {
      params: queryParameters,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }).catch((error) => {
      throw new Error(error);
    });
  }

  getAllCommandsByDeviceKey(
    input: GetAllCommandsByDeviceKeyRequest,
    cancelToken?: CancelToken
  ): Promise<AxiosResponse<CommandResponse>> {
    const { deviceKey, ...queryParameters } = input;
    const accessToken = localStorage.getItem('accessToken');
    return axiosInstance.get<CommandResponse>(`${this.baseUrl}/devices/${deviceKey}`, {
      cancelToken,
      params: queryParameters,
      headers: {
        Accept: 'application/get-commands-v2+json',
        Authorization:  `Bearer ${accessToken}`,
      },
    }).catch((error) => {
      throw new Error(error);
    });
  }

  patchCommandsByDeviceKey(
    input: PatchCommandsByDeviceKeyRequest,
  ): Promise<AxiosResponse<Array<CommandEntity>>> {
    const { deviceKey, body } = input;
    const accessToken = localStorage.getItem('accessToken');
    return axiosInstance.patch<Array<CommandEntity>>(
      `${this.baseUrl}/devices/${deviceKey}/commandStatus`,
      body,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'application/json',
        },
      },
    ).catch((error) => {
      throw new Error(error);
    });
  }

  postCommandsByDeviceKey(
    input: PostCommandsByDeviceKeyRequest,
  ): Promise<AxiosResponse<Array<CommandEntity>>> {
    const { deviceKey, deviceData } = input;
    const accessToken = localStorage.getItem('accessToken');
    return axiosInstance.post<Array<CommandEntity>>(`${this.baseUrl}/devices/${deviceKey}`, deviceData, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
      },
    }).catch((error) => {
      throw new Error(error);
    });
  }
}

export default Command;
